import * as React from 'react'
import { useSelector } from 'react-redux'
import { isEmpty, isLoaded } from 'react-redux-firebase'
import { Route, Switch } from 'react-router-dom'

import { ApplicationState } from '../core/store'
import IndexPage from './main/IndexPage'
import { Redirect } from 'react-router-dom'
import NoMatch from './main/NoMatch'
import GameDashboard from './game_dashboard/GameDashboard'

const PrivateRoute = (props: any) => {
  const auth = useSelector((state: ApplicationState) => state.firebase!.auth)
  return auth !== undefined && isLoaded(auth) && !isEmpty(auth) ? (
    <Route {...props} />
  ) : (
    <Redirect to={{ pathname: '/login/', state: { currentLocation: props.computedMatch.url } }} />
  )
}

const Routes: React.SFC = () => (
  <Switch>
    <Route exact path="/" component={IndexPage} />
    <PrivateRoute path="/game/:id/dashboard" component={GameDashboard} />
    <Route component={NoMatch} />
  </Switch>
)

export default Routes
